import React, { Component } from 'react'

import { navigateTo } from 'gatsby-link'


import { zone } from '../../../zone'

class ModuloRicerca extends Component {
    constructor(props) {
        super(props);
        this.state = { value: '', zone: [] }
    }

    componentDidMount() {
        this.setState({ zone })
    }

    handleChange(event) {
        this.setState({ value: event.target.value });
    }

    submitSearch(event) {
        event.preventDefault()

        localStorage.setItem('prowed_location', this.state.value)

        navigateTo('/ricerca-fotografo-o-videografo-professionista/')
    }

    render() {
        return (
            <section className="uk-section uk-text-center" style={{ background: this.props.bak }}>
                <div className="uk-container uk-container-xsmall uk-text-center uk-section uk-padding-remove-top">
                    <h2 className="uk-margin-remove uk-h1">{this.props.titolo}</h2>
                </div>

                <form onSubmit={this.submitSearch.bind(this)} >
                    <div className="uk-margin">

                        <select value={this.state.value} onChange={this.handleChange.bind(this)} className="uk-select uk-form-width-medium uk-form-large uk-form-width-large uk-margin-small-right">
                            <option value='' >{this.props.placeh}</option>
                            {this.state.zone.map((zona, index) => <option key={index} value={zona.value} >{zona.testo}</option>)}
                        </select>

                        <button disabled={this.state.value === '' ? true : false} className="uk-button uk-button-danger uk-form-large uk-form-width-small" type="submit" >Cerca</button>
                    </div>
                </form>
            </section>
        )
    }
}


export default ModuloRicerca


// WEBPACK FOOTER //
// ./src/components/homepage/moduloricerca/index.js